import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';

import { CommentButtonPlaceholder } from './CommentButtonPlaceholder.tsx';

export const CommentIconLoadable = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CommentIcon" */ './CommentIcon.tsx')).CommentIcon,
	loading: () => <CommentButtonPlaceholder />,
});
